import { Box, Link, Typography, useTheme } from "@mui/material";
import React from "react";
import SparklingSvg from "SvgIcons/SparklingSvg";
import { KBO_UPDATE_HELP_ARTICLE_URL } from "./kboUpdateAnnouncement";

type Props = {
    inline?: boolean;
};

export const KBoUpdateBanner = ({ inline }: Props) => {
    const theme = useTheme();

    return (
        <Box
            id="kbo-update-banner"
            sx={{
                display: "flex",
                alignItems: "flex-start",
                flexShrink: 0,
                columnGap: 1,
                paddingBlock: 1.25,
                paddingInline: 1.5,
                borderRadius: `${theme.shape.borderRadius * 2}px`,
                backgroundImage:
                    "linear-gradient(90deg, #F3F4F6 0%, #C3CEF0 100%)",
                maxWidth: "100%",
                width: inline ? "fit-content" : "100%",
                marginInline: inline ? "auto" : undefined,
            }}
        >
            <SparklingSvg
                brandBlend
                width={16}
                height={16}
                style={{
                    display: "block",
                    flexShrink: 0,
                    marginTop: "2px",
                }}
            />
            <Typography
                sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    color: theme.palette.gray[700],
                }}
            >
                KBo was updated. Same assistant, sharper answers.{" "}
                <Link
                    href={KBO_UPDATE_HELP_ARTICLE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        color: theme.palette.primary.main,
                        fontWeight: 600,
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        ":hover": { textDecoration: "underline" },
                    }}
                >
                    See what changed
                </Link>
            </Typography>
        </Box>
    );
};

export default KBoUpdateBanner;
